import { quotationFormStyles } from "./QuotationForm.styles";

import * as moment from "moment";
import * as React from "react";
import { chain } from "lodash";

import { WithStyles, Paper, IconButton, Grid, withStyles } from "@material-ui/core";

import { Beneficiary } from "../../types/Beneficiary";
import { Form } from "../../types/Form";

import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";

import InputDate from "../InputDate/InputDate";
import InputText from "../InputText/InputText";
import InputSelect from "../InputSelect/InputSelect.component";
import DeleteIcon from "../Icons/DeleteIcon";

interface QuotationFormBeneficiaryProps extends WithStyles<typeof quotationFormStyles> {
    index: number;
    beneficiaries: Beneficiary[];
    withQuoteParts?: boolean;
    onRemove();
    onChange(beneficiary: Beneficiary);
}

type QuotationFormBeneficiaryState = {
    form: Form<Beneficiary>;
};

class QuotationFormBeneficiary extends React.Component<QuotationFormBeneficiaryProps, QuotationFormBeneficiaryState> {
    formBuilder = null;

    /**
     *
     */
    public componentWillMount() {
        this.updateState(this.props);
    }

    /**
     *
     * @param nextProps
     */
    public componentWillReceiveProps(nextProps: QuotationFormBeneficiaryProps) {
        this.updateState(nextProps);
    }

    /**
     *
     */
    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(form.values);
    }

    /**
     *
     */
    public render() {
        if (!this.state) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const { theme } = this.props;
        return (
            <Paper className={this.props.classes.beneficiaryBox}>
                {this.props.index > 0 ? (
                    <Grid container={true} spacing={0}>
                        <Grid item={true} sm={12} style={{ textAlign: "right" }}>
                            <IconButton onClick={this.props.onRemove}>
                                <DeleteIcon nativeColor={theme.palette.primary.main} />
                            </IconButton>
                        </Grid>
                    </Grid>
                ) : null}
                <Grid container={true} spacing={16}>
                    <Grid item={true} sm={4}>
                        <InputText {...uiForm.fields.lastname} />
                    </Grid>
                    <Grid item={true} sm={4}>
                        <InputText {...uiForm.fields.birthname} />
                    </Grid>
                    <Grid item={true} sm={4}>
                        <InputText {...uiForm.fields.firstname} />
                    </Grid>

                    <Grid item={true} sm={4}>
                        <InputDate {...uiForm.fields.birthdate} />
                    </Grid>
                    <Grid item={true} sm={4}>
                        <InputText {...uiForm.fields.cityOfBirth} />
                    </Grid>
                    {this.props.withQuoteParts ? (
                        <Grid item={true} sm={4}>
                            <InputSelect {...uiForm.fields.quotePart} />
                        </Grid>
                    ) : null}
                    <Grid item={true} sm={12}>
                        <InputText {...uiForm.fields.address} />
                    </Grid>
                </Grid>
            </Paper>
        );
    }

    /**
     *
     * @param props
     */
    private updateState(props: QuotationFormBeneficiaryProps) {
        this.formBuilder = new UiFormBuilder<Beneficiary>();

        this.formBuilder
            .addField(`firstname`, {
                props: {
                    label: "Prénom",
                    placeholder: "Prénom",
                    required: true,
                },
            })
            .addField(`birthname`, {
                props: {
                    label: "Nom de naissance",
                    placeholder: "Nom de naissance",
                },
            })
            .addField(`lastname`, {
                props: {
                    label: "Nom",
                    placeholder: "Nom",
                    required: true,
                },
            })
            .addField(`birthdate`, {
                props: {
                    label: "Date de naissance",
                    required: true,
                    dateProps: {
                        min: moment().subtract(100, "year").format("YYYY-MM-DD"),
                        max: moment().format("YYYY-MM-DD"),
                    },
                },
            })
            .addField(`cityOfBirth`, {
                props: {
                    label: "Lieu de naissance",
                    placeholder: "Lieu de naissance",
                    required: true,
                },
            })
            .addField(`quotePart`, {
                props: {
                    items: this.getQuotePartItems(props.beneficiaries, props.index),
                    label: "Quote part",
                    required: true,
                    customValidation: (evt, reporter) => {
                        return null;
                    },
                },
            })
            .addField(`address`, {
                props: {
                    label: "Adresse complète",
                    placeholder: "Adresse complète",
                    required: true,
                    maxLength: 53,
                },
            })
            .onChange(this.onChange.bind(this));

        this.setState({
            form: {
                fields: {},
                errors: [],
                values: props.beneficiaries[props.index],
            },
        });
    }

    /**
     *
     * @param beneficiaries
     * @param index
     */
    private getQuotePartItems(beneficiaries: Beneficiary[], index: number) {
        if (beneficiaries.length === 1) {
            return [
                {
                    name: 100 + "",
                    label: "100%",
                },
            ];
        }
        const max = chain(beneficiaries)
            .filter((b: Beneficiary, i: number) => i !== index)
            .sumBy((b: Beneficiary) => (b.quotePart ? parseInt(b.quotePart, 10) : 0))
            .value();
        return this.getItems(100 - max);
    }

    /**
     *
     * @param max
     */
    private getItems(max: number) {
        let items = [];
        for (let i = 0; i <= max; i++) {
            items.push({
                name: i + "",
                label: i + " %",
            });
        }
        return items;
    }
}

export default withStyles({}, { withTheme: true })(QuotationFormBeneficiary);



// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormBeneficiary.tsx